import React from 'react'
import useStyles from './styles'
import { Typography } from '@material-ui/core'
import classnames from 'clsx'

const HelpText = ({ children, className }) => {
  const classes = useStyles()

  return (
    <Typography
      variant="h2"
      className={classnames(classes.helpText, className)}
    >
      {children}
    </Typography>
  )
}

export default HelpText



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/HelpText/index.jsx